import { Memory } from '../types/types'
import { Timestamp } from 'firebase/firestore'
// Services&Helper functions
import writeService from '../services/write'
import deleteService from '../services/delete'
import helperFunctions from './helperFunctions'

// Function to retrieve which shareCards we want to create
const _getCards = (mem: Memory) => {
    let cards: string[] = ['memory']
    const { announcements } = mem

    announcements.deceased.text && cards.push('deceased')
    announcements.funeral.text && cards.push('funeral')
    announcements.greeting.text && cards.push('greeting')

    return cards
}

const MemoryHelperFunctions = () => {
    const MS_PER_DAY = 1000 * 60 * 60 * 24

    return {
        checkIfTwoWeeksPassed: (today: Date, memory: Memory) => {
            // Create death date
            const deathInMS = (memory.death as Timestamp).seconds * 1000
            const deathDate = new Date(deathInMS)
            // Compare the death date with today's date
            const d1 = Date.UTC(
                today.getFullYear(),
                today.getMonth(),
                today.getDate()
            )
            const d2 = Date.UTC(
                deathDate.getFullYear(),
                deathDate.getMonth(),
                deathDate.getDate()
            )
            const daysPassed = (d1 - d2) / MS_PER_DAY

            // If more than 14 days has passed, return true. Else, return false
            return daysPassed > 28
        },

        checkIfFuneralFinished: (today: Date, memory: Memory) => {
            // Check if two weeks since death
            const twoWeeksPassed =
                MemoryHelperFunctions().checkIfTwoWeeksPassed(today, memory)
            const { funeral } = memory.announcements
            // If funeral is finished, return true
            if (funeral.hold === 'FINISHED' || funeral.hold === 'SILENTLYFIN') {
                return true
            }
            // If funeral will be announced later and there has been more than two weeks
            // return true
            else if (funeral.hold === 'LATER' && twoWeeksPassed) return true
            // If the deceased one is newly deceased (< 14) return false
            else if (funeral.hold === 'LATER' && !twoWeeksPassed) return false
            // If funeral will be announced SILENTLY and there has been more than two weeks
            // return true
            else if (funeral.hold === 'SILENTLY' && twoWeeksPassed) return true
            // If the deceased one is newly deceased (< 14) return false
            else if (funeral.hold === 'SILENTLY' && !twoWeeksPassed)
                return false
            // Else check if funeralDate has passed (more than one day since funeral)
            // TODO: Could this have an API call to check if we need to change memory?
            const { funeralDate } = funeral
            const dateInMS = (funeralDate as Timestamp).seconds * 1000
            const dateFuneral = new Date(dateInMS)
            const d1 = Date.UTC(
                today.getFullYear(),
                today.getMonth(),
                today.getDate()
            )
            const d2 = Date.UTC(
                dateFuneral.getFullYear(),
                dateFuneral.getMonth(),
                dateFuneral.getDate()
            )
            const daysPassed = (d2 - d1) / MS_PER_DAY

            return daysPassed <= -1
        },
        changeFollowState: (followState: boolean, mid: string, uid: string) => {
            if (followState) {
                writeService.followMemory(mid, uid)
            } else {
                deleteService.unfollowMemory(mid, uid)
            }
        },
        refetchCards: async (memory: Memory, mid: string) => {
            // Create birth and death strings
            const birthString = helperFunctions.getDate(memory.birth)
            const deathString = helperFunctions.getDate(memory.death)
            await fetch('/api/openGraphImage', {
                method: 'POST',
                body: JSON.stringify({
                    memory: {
                        ...memory,
                        birth: birthString,
                        death: deathString,
                    },
                    mid,
                    cards: _getCards(memory),
                }),
                headers: {
                    'Content-Type': 'application/json',
                },
            }).catch((err) => {
                console.error(err)
                return false
            })

            return true
        },
    }
}
export default MemoryHelperFunctions()
